module.exports = __webpack_public_path__ + "luckycatresort-build/img/pattern-1.2fbb4919.svg";